// import {useState} from "react";

const MyCollection = () =>{
    
    return (<>
    <h1 >No Collections found. </h1>
    </>)

}

export default MyCollection
